var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIncompleteIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1372_1911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.6666C4.31816 14.6666 1.3335 11.6819 1.3335 7.99992C1.3335 4.31792 4.31816 1.33325 8.00016 1.33325C11.6822 1.33325 14.6668 4.31792 14.6668 7.99992C14.6668 11.6819 11.6822 14.6666 8.00016 14.6666ZM7.3335 9.99992V11.3333H8.66683V9.99992H7.3335ZM8.66683 8.90325C9.20261 8.74177 9.66257 8.39322 9.96293 7.92108C10.2633 7.44894 10.3841 6.88462 10.3033 6.3309C10.2225 5.77717 9.94557 5.27088 9.52284 4.90422C9.10011 4.53757 8.55975 4.33494 8.00016 4.33325C7.46073 4.33321 6.93794 4.52002 6.52069 4.86191C6.10344 5.20381 5.8175 5.67967 5.7115 6.20859L7.0195 6.47059C7.05662 6.28487 7.14571 6.11352 7.27641 5.97646C7.40711 5.83941 7.57404 5.74228 7.75778 5.69639C7.94152 5.6505 8.13452 5.65773 8.31431 5.71723C8.4941 5.77674 8.6533 5.88608 8.77339 6.03253C8.89347 6.17898 8.96949 6.35651 8.99262 6.54448C9.01574 6.73245 8.98501 6.92312 8.90401 7.09431C8.82301 7.2655 8.69506 7.41016 8.53505 7.51147C8.37504 7.61278 8.18955 7.66657 8.00016 7.66659C7.82335 7.66659 7.65378 7.73682 7.52876 7.86185C7.40373 7.98687 7.3335 8.15644 7.3335 8.33325V9.33325H8.66683V8.90325Z",
    fill: "#6C7E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1372_1911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIncompleteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IncompleteIcon.104a85e6.svg";
export { ForwardRef as ReactComponent };